import { isSubscriptionOnHold, type SubscriptionLike } from "@/lib/billing/entitlements";
import { getCanonicalSubscriptionSlugForPriceId, type SubscriptionSlug } from "@/utils/stripe/subscription-slugs";

const ENTITLED_STATUSES = new Set(["active", "trialing"]);

export function getEntitledSubscriptionSlugs(rows: readonly SubscriptionLike[]): Set<SubscriptionSlug> {
  const slugs = new Set<SubscriptionSlug>();
  for (const row of rows) {
    if (!ENTITLED_STATUSES.has(row.status ?? "")) continue;
    if (isSubscriptionOnHold(row)) continue;
    const slug = getCanonicalSubscriptionSlugForPriceId(row.price_id);
    if (slug) slugs.add(slug);
  }
  return slugs;
}
